import { render } from "./MenuSet.vue?vue&type=template&id=44715142&scoped=true"
import script from "./MenuSet.vue?vue&type=script&lang=js"
export * from "./MenuSet.vue?vue&type=script&lang=js"

import "./MenuSet.vue?vue&type=style&index=0&id=44715142&scoped=true&lang=css"
import "./MenuSet.vue?vue&type=style&index=1&id=44715142&lang=css"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44715142"]])

export default __exports__